import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GruppeTier } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { Betriebskontakt } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt';
import { GruppeTierService } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-herkunft-setzen-dialog',
    templateUrl: './herkunft-setzen-dialog.component.html',
    styleUrls: ['./herkunft-setzen-dialog.component.scss'],
})
export class HerkunftSetzenDialogComponent {
    selectedKontakt: Betriebskontakt | null = null;
    isSaving = false;
    removeHerkunft = false;

    constructor(
        private readonly dialogRef: MatDialogRef<HerkunftSetzenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { tiere: GruppeTier[] },
        private readonly gruppeTierService: GruppeTierService,
        private readonly messageService: MessageService,
    ) {}

    onKontaktSelected(kontakt: Betriebskontakt): void {
        this.selectedKontakt = kontakt;
        this.removeHerkunft = false;
    }

    onKontakteSelected(kontakte: Betriebskontakt[]): void {
        if (kontakte?.length > 0) {
            this.onKontaktSelected(kontakte[0]);
        }
    }

    clearSelection(): void {
        this.selectedKontakt = null;
        this.removeHerkunft = true;
    }

    cancel(): void {
        this.dialogRef.close(false);
    }

    save(): void {
        if (!this.data?.tiere?.length) {
            this.messageService.errorMessage('Keine Tiere ausgewählt!', null);
            return;
        }

        if (!this.selectedKontakt && !this.removeHerkunft) {
            this.messageService.errorMessage('Bitte wählen Sie einen Herkunftsbetrieb aus oder entfernen Sie ihn.', null);
            return;
        }

        this.isSaving = true;
        this.gruppeTierService
            .updateHerkunftForTiere(this.data.tiere, this.removeHerkunft ? null : this.selectedKontakt)
            .subscribe({
                next: success => {
                    this.isSaving = false;
                    if (success) {
                        const message = this.removeHerkunft
                            ? 'Herkunftsbetrieb erfolgreich entfernt.'
                            : 'Herkunftsbetrieb für alle ausgewählten Tiere gesetzt.';
                        this.messageService.infoMessage(message);
                        this.dialogRef.close(true);
                    } else {
                        this.dialogRef.close(false);
                    }
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Herkunftsbetrieb konnte nicht aktualisiert werden!', err);
                },
            });
    }
}



